module.exports = __webpack_public_path__ + "img/icn_consulting.2273999a.png";